import Lenis from 'lenis'

const USE_LENIS = false;

let hasLenis = false;

let lenis = {};

if (!window.acf) {

    if (USE_LENIS) {

        if (!hasLenis) {
            
            lenis = new Lenis({
                // wrapper: document.body,
                autoRaf: false,
            });
            const resizeObserver = new ResizeObserver(entries => {
                lenis.reset();
                lenis.resize();
            });
            resizeObserver.observe(document.body);
            function raf(time) {
                lenis.raf(time);
                requestAnimationFrame(raf);
            }
            requestAnimationFrame(raf);
        
            hasLenis = true;
        }

        // lenis = new Lenis();
        // function raf(time) {
        //     lenis.raf(time);
        //     requestAnimationFrame(raf);
        // }
        // requestAnimationFrame(raf);

    }
    else {

        const callbacks = {};
        document.addEventListener('scroll', e => {
            callbacks['scroll']?.forEach(cb => {
                cb({
                    animatedScroll: window.pageYOffset,
                });
            });
        });
        lenis.on = (eventName, cb) => {
            callbacks[eventName] = callbacks[eventName] || []
            callbacks[eventName].push(cb);
        }

    }

}

export default lenis;